<template>
  <div class="technical">
    <div class="doTitle">
      <!--      <li class="tit">{{ $t("DAO.index") }}</li>-->
      <div class="sub">
        <!-- <li>{{ $t("DAO.technology1") }}</li> -->
        <p>{{ $t("DAO.come") }}</p>
      </div>
    </div>

    <div class="content">
      <div class="img">
        <img src="../../assets/m/imageA.png" />
      </div>
      <div class="adv">
        <div class="describe">{{ $t("DAO.reward") }}</div>
        <div class="detail">{{ $t("DAO.rewardTail") }}</div>
      </div>

      <div class="img">
        <img src="../../assets/m/imageB.png" />
      </div>
      <div class="adv">
        <div class="describe">{{ $t("DAO.eco") }}</div>
        <div class="detail">{{ $t("DAO.ecoTail") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.w1352 {
  /*width: 1200px;*/
  margin: 0 auto;
}
.w1300 {
  /*width: 67%;*/
  margin: 0 auto;
}
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}
li {
  list-style: none;
}
.technical {
  text-align: center;
  margin-top: 200px;
  .doTitle {
    text-align: center;
    .tit {
      font-size: 30px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #000000;
      line-height: 35px;
      margin-bottom: 20px;
    }
    .sub {
      li {
        font-size: 30px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #000000;
        line-height: 35px;
        -webkit-background-clip: text;
        margin-bottom: 20px;
      }
      p {
        width: 648px;
        height: 165px;
        font-size: 64px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 83px;
        margin: 0 auto;
      }
      margin: 0 auto;
      text-align: center;
    }
  }
  .content {
    margin-top: 120px;
    img {
      width: 750px;
      height: 713px;
    }
    .describe {
      font-size: 40px;
      font-family: Poppins-Bold, Poppins;
      font-weight: bold;
      color: #000000;
      line-height: 47px;
      margin-bottom: 10px;
    }
    .detail {
      width: 650px;
      font-size: 28px;
      margin: 0 auto;
      font-weight: 600;
      color: #000000;
      line-height: 45px;
    }
    .adv {
      margin-top: 40px;
      margin-bottom: 60px;
    }
  }
}
</style>
